import { inventoryAdjustmentReasonIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";
import { inventoryAdjustmentReasonDirectionSchema } from "./direction";

export const listInventoryAdjustmentReasons = {
  name: "listInventoryAdjustmentReasons" as const,
  input: z.object({}),
  output: z.object({
    reasons: z.array(
      z.object({
        id: inventoryAdjustmentReasonIdFormat.schema,
        name: z.string(),
        direction: inventoryAdjustmentReasonDirectionSchema.nullable(),
        editable: z.boolean(),
      }),
    ),
  }),
};

export type InventoryAdjustmentReason = z.infer<
  typeof listInventoryAdjustmentReasons.output
>["reasons"][number];
